import 'styled-components'
import styledNormalize from 'styled-normalize'
import { createGlobalStyle } from 'styled-components'

/**
 * Global base styles
 */

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}

  /* Add fonts here */
  @font-face {
    font-family: 'ProximaNova';
    font-weight: 300;
    src: url('/fonts/ProximaNova/ProximaNova-Light.otf') format('opentype');
  }

  @font-face {
    font-family: 'ProximaNova';
    font-weight: 400;
    src: url('/fonts/ProximaNova/ProximaNova-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'ProximaNova';
    font-weight: 400;
    font-style: italic;
    src: url('/fonts/ProximaNova/ProximaNova-RegItalic.otf') format('opentype');
  }

  @font-face {
    font-family: 'ProximaNova';
    font-weight: 500;
    src: url('/fonts/ProximaNova/ProximaNova-Semibold.otf') format('opentype');
  }

  @font-face {
    font-family: 'ProximaNova';
    font-weight: 700;
    src: url('/fonts/ProximaNova/ProximaNova-Bold.otf') format('opentype');
  }


  html,
  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  html {
    box-sizing: border-box;
    height: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  img {
    max-width: 100%;
  }

  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  /* clears the 'X' from Internet Explorer */
  input[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  input[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  /* clears the 'X' from Chrome */
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px white inset;
    transition: background-color 5000s ease-in-out 0s;
  }
 `

 

export default GlobalStyle
